import React, { Fragment, useRef, useState } from "react";
import Input from "../../components/DataEntry/Input";
import Logo from "../../../src/assets/images/rearmrobotics-white.png";
import authService from "../../services/AuthService";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submited, setSubmited] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState("");

  const handleChange = (e) => {
    console.log(e.target.value);
  };

  const submitForgotPassword = async () => {
    setLoading(true);
    try {
      const request = await authService
        .forgotPassword({ email })
        .then((response) => {
          if (response.error) {
            setValidationErrors(response.error);
            setLoading(false);
          } else if (response.errors) {
            setValidationErrors(response.errors[0].message);
            setLoading(false);
          } else {
            setSubmited(true);
            setLoading(false);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="forgot-password">
      <div className="container">
        <img style={{ width: "70%" }} src={Logo} alt="logo" />
        {submited ? (
          <div>
            <div
              style={{
                fontSize: "0.9rem",
                textAlign: "center",
                lineHeight: "1.3rem",
                fontWeight: "100",
                margin: "1rem 0",
              }}
            >
              Thank you for submitting your email address. You will receive an
              email shortly with instructions on how to reset your password.
              Please be sure to check your spam folder if you don't see the
              email in your inbox. If you have any further questions or
              concerns, please don't hesitate to reach out to us.
            </div>
          </div>
        ) : (
          <Fragment>
            <span className="title">Forgot Password</span>
            <Input
              placeholder="Email"
              className="input-classic"
              type="email"
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              //@ts-ignore
              // ref={(e) => inputRef.current(e.target.value)}
              status={validationErrors && "error"}
              validationMessage={validationErrors}
            />
            <button
              className={`button ${loading && "button--loading"}`}
              onClick={submitForgotPassword}
              style={{ margin: "1rem auto 0" }}
              disabled={loading}
            >
              {loading ? "" : "SUBMIT"}
            </button>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
